<template>
  <div class="bbp-list-projects-main-header">
    <h2 class="bbp-title-page">
      Projects
    </h2>
    <transition name="bbp-fade">
      <div
        v-if="isHeader"
        class="bbp-list-projects-main-header-info"
      >
        <div class="bbp-list-projects-main-header-info-item">
          <div class="bbp-list-projects-main-header-info-item__text">Total projects: </div>
          <div
            class="bbp-list-projects-main-header-info-item__text bbp-list-projects-main-header-info-item__text_value"
          >
            {{ totalDocs }}
          </div>
        </div>
        <div class="bbp-list-projects-main-header-info-item">
          <div class="bbp-list-projects-main-header-info-item__text">Total value:</div>
          <div
            class="bbp-list-projects-main-header-info-item__text bbp-list-projects-main-header-info-item__text_value"
          >
            {{ totalAmount }}
          </div>
          <div
            v-html="AED_ICON()"
            class="bbp-list-projects-main-header-info-item__icon"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import ProjectsApi from '@/api/Projects/api'
import convertNumber from '@/mixin/convertNumber'
import {AED_ICON} from '@/constants/icons'

export default {
  name: 'ListOfProjectsHeader',
  mixins: [convertNumber],
  props: {
    fullInfo: {
      type: Object,
      default: () => ({})
    },
    isHeader: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    project: {
      totalAmount: '',
      totalDocs: '',
      id: ''
    },
    AED_ICON
  }),
  computed: {
    projectUserId () {
      return this.$store.getters.projectUserId
    },
    totalAmount () {
      const { totalAmount: totalAmountFull } = this.fullInfo
      const {totalAmount} = this.project
      return this.projectUserId ? this.convertNumber(totalAmount) : this.convertNumber(totalAmountFull)
    },
    totalDocs () {
      const { totalDocs: totalDocsFull } = this.fullInfo
      const { totalDocs } = this.project
      return this.projectUserId ? totalDocs : totalDocsFull
    }
  },
  watch: {
    projectUserId (newVal) {
      this.getProjects(newVal)
    }
  },
  methods: {
    async getProjects (id) {
      if (!this.isHeader) return
      try {
        const { data } = await ProjectsApi.getProjects({projectManager: id})
        const { totalAmount, totalDocs } = data
        this.project = {
          totalAmount,
          totalDocs,
          id: this.projectUserId
        }
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

  .bbp-list-projects-main-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .bbp-list-projects-main-header-info {
    display: flex;
    grid-gap: 0 12px;
  }

  .bbp-list-projects-main-header-info-item {
    display: flex;
    align-items: center;
    min-width: 140px;
    background: $color-white;
    border-radius: 4px;
    padding: 9px 12px 9px 12px;

    &__text {
      color: $color-denim;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;

      &_value {
        font-weight: 600;
        margin: 0 8px 0 15px;
      }
    }

    &__icon {
      margin: 0 8px 0 -3px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Projects/ListOfProjects/ListOfProjectsHeader.vue